import { createApp } from 'vue';

import VideoPlayer from '../components/video/video.vue';

// Mounts videos rendered by templates/partials/_video.twig while VideoPlayer stays in compat mode.
const app = createApp({
	components: {
		VideoPlayer
	}
});

app.config.compilerOptions.whitespace = 'preserve';
app.mount('#videoPlayer');
